module.exports = __webpack_public_path__ + "not-allowed.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/not-allowed.svg?color1=%23333333&color2=
// module id = 2206
// module chunks = 67